import LegalComplianceDefaultWidget from './ModuleWidgets/LegalComplianceDefaultWidget';
import IntelligenceDefaultWidget from './ModuleWidgets/IntelligenceDefaultWidget';
import LawFinderDefaultWidget from './ModuleWidgets/LawFinderDefaultWidget';
import CorrectiveActionsDefaultWidget from './ModuleWidgets/CorrectiveActionsDefaultWidget';
import ModuleBridgeFolderDefaultWidget from './ModuleWidgets/ModuleBridgeFolderDefaultWidget';
import GlobalLegalComplianceDefaultWidget from './ModuleWidgets/GlobalLegalComplianceDefaultWidget';
import DynamicFormDefaultWidget from './ModuleWidgets/DynamicFormDefaultWidget';
import SecureFilesDefaultWidget from './ModuleWidgets/SecureFilesDefaultWidget';
import ChemicalTradingDefaultWidget from './ModuleWidgets/ChemicalTradingDefaultWidget';
import SaicaReportsDefaultWidget from './ModuleWidgets/SaicaReportsDefaultWidget';
import DefaultWidgetTemplate from './DefaultWidgetTemplate';
import InecoRiskManagerDefaultWidget from './ModuleWidgets/InecoRiskManagerDefaultWidget';
import NewsletterManagerDefaultWidget from './ModuleWidgets/NewsletterManagerDefaultWidget';
import UserManagementDefaultWidget from './ModuleWidgets/UserManagementDefaultWidget';
import CommunicationPipelineDefaultWidget from './ModuleWidgets/CommunicationPipelineDefaultWidget';
import ResourceManagerDefaultWidget from './ModuleWidgets/ResourceManagerDefaultWidget';
import DocumentManagerDefaultWidget from './ModuleWidgets/DocumentManagerDefaultWidget';
import TotalEnergiesRiskDefaultWidget from './ModuleWidgets/TotalEnergiesRiskDefaultWidget';
import EnvironmentalAspectsAssessmentDefaultWidget from './ModuleWidgets/EnvironmentalAspectsAssessmentDefaultWidget';
import AdvancedSearchDefaultWidget from './ModuleWidgets/AdvancedSearchDefaultWidget';
import SurveyDefaultWidget from './ModuleWidgets/SurveyDefaultWidget';

const ModuleWidgetSwitch = (props) => {
  const { type, module } = props;
  switch (type) {
    case 'LegalCompliance':
      return <LegalComplianceDefaultWidget module={module} />;
    case 'Intelligence':
      return <IntelligenceDefaultWidget module={module} />;
    case 'LawFinder':
      return <LawFinderDefaultWidget module={module} />;
    case 'CorrectiveActions':
      return <CorrectiveActionsDefaultWidget module={module} />;
    case 'ModuleBridgeFolder':
      return <ModuleBridgeFolderDefaultWidget module={module} />;
    case 'GlobalLegalCompliance':
      return <GlobalLegalComplianceDefaultWidget module={module} />;
    case 'DynamicForm':
      return <DynamicFormDefaultWidget module={module} />;
    case 'SecureFiles':
      return <SecureFilesDefaultWidget module={module} />;
    case 'ChemicalTrading':
      return <ChemicalTradingDefaultWidget module={module} />;
    case 'NewsletterManager':
      return <NewsletterManagerDefaultWidget module={module} />;
    case 'InecoRiskManager':
      return <InecoRiskManagerDefaultWidget module={module} />;
    case 'SaicaReports':
      return <SaicaReportsDefaultWidget module={module} />;
    case 'UserManagement':
      return <UserManagementDefaultWidget module={module} />;
    case 'CommunicationPipeline':
      return <CommunicationPipelineDefaultWidget module={module} />;
    case 'ResourceManager':
      return <ResourceManagerDefaultWidget module={module} />;
    case 'DocumentManager':
      return <DocumentManagerDefaultWidget module={module} />;
    case 'TotalEnergiesRisk':
      return <TotalEnergiesRiskDefaultWidget module={module} />;
    case 'EnvironmentalAspectsAssessment':
      return <EnvironmentalAspectsAssessmentDefaultWidget module={module} />;
    case 'AdvancedSearch':
      return <AdvancedSearchDefaultWidget module={module} />;
    case 'Survey':
      return <SurveyDefaultWidget module={module} />;
    default:
      return (
        <DefaultWidgetTemplate />
      );
  }
};

export default ModuleWidgetSwitch;
